import styled from 'styled-components';

export const Content02 = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem 2rem;
`;

export const Row011 = styled.div`
  width: 100%;
  display: flex;
  gap: 2rem;
  flex-direction: row;
`;

export const Data012 = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-height: 600px;
  overflow-y: auto;
`;

export const Data022 = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-height: 600px;
  overflow-y: auto;
`;
